import { render, staticRenderFns } from "./carihesap.vue?vue&type=template&id=10b988f7&"
import script from "./carihesap.vue?vue&type=script&lang=js&"
export * from "./carihesap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports